module.exports = __webpack_public_path__ + "static/media/bum1_munich.0162a07f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/bum1_munich.jpg
// module id = 403
// module chunks = 0